"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:!0}),exports["default"]=void 0;var _extends2=_interopRequireDefault(require("@babel/runtime/helpers/extends")),_react=_interopRequireDefault(require("react")),_material=require("@mui/material/"),_propTypes=_interopRequireDefault(require("prop-types")),Switch=function(/** @type {SwitchProps} props */a){return/*#__PURE__*/_react["default"].createElement(_material.Switch,(0,_extends2["default"])({"data-testid":"clipSwitch"},a))};Switch.propTypes={/**
   * If set to `true`, the component is checked.<br />**Type:**
   */checked:_propTypes["default"].bool,/**
   * The icon to display when the component is checked.<br />**Type:**
   */checkedIcon:_propTypes["default"].node,/**
   * Override or extend the styles applied to the component.<br />**Type:**
   */classes:_propTypes["default"].object,/**
   * The color of the component. It supports both default and custom theme colors.<br />**Type:**
   */color:_propTypes["default"].oneOf(["default","primary"]),/**
   * If set to `true`, the component is disabled.<br />**Type:**
   */disabled:_propTypes["default"].bool,/**
   * If set to `true`, the ripple effect is disabled.<br />**Type:**
   */disableRipple:_propTypes["default"].bool,/**
   * The default checked state. Use when the component is not controlled.<br />**Type:**
   */defaultChecked:_propTypes["default"].bool,/**
   * If given, uses a negative margin to counteract the padding on one side
   * (this is often helpful for aligning the left or right side of the icon with content above or below,
   * without ruining the border size and shape).<br />**Type:**
   */edge:_propTypes["default"].oneOf(["end","start",!1]),/**
   * The icon to display when the component is unchecked.<br />**Type:**
   */icon:_propTypes["default"].node,/**
   * 	The id of the `input` element.<br />**Type:**
   */id:_propTypes["default"].string,/**
   * Attributes applied to the `input` element.<br />**Type:**
   */inputProps:_propTypes["default"].object,/**
   * Callback fired when the state is changed.
   *
   * **Signature:**
   *
   * `function(event: React.ChangeEvent<HTMLInputElement>) => void`
   *
   * *event:* The event source of the callback. You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).<br />**Type:**
   */onChange:_propTypes["default"].func,/**
   * If set to `true`, the `input` element is required.<br />**Type:**
   */required:_propTypes["default"].bool,/**
   * The size of the component. `small` is equivalent to the dense switch styling.<br />**Type:**
   */size:_propTypes["default"].oneOf(["medium","small"]),/**
   * The value of the component. The DOM API casts this to a string. The browser uses "on" as the default value.<br />**Type:**
   */value:_propTypes["default"].any},Switch.defaultProps={color:"primary",edge:!1};var _default=Switch;exports["default"]=_default;